var _defs, _linearGradient;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatasetUnarchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 37.581,
    y1: 25.944,
    x2: 33.5,
    x1: 33.5,
    id: "b",
    gradientTransform: "translate(-9.533 .108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4b4b4b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b3b3b",
    offset: 1
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 24,
    y1: 24,
    x2: 39,
    x1: 9,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fede00",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd000",
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffca28",
      fillOpacity: 1
    },
    d: "M39 41a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2v34z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#b)"
    },
    d: "M26.595 26.956a.995.995 0 0 0-.989-.848h-3.279a.995.995 0 0 0-.988.848c-.269 1.802-.872 5.913-.872 6.652a3.5 3.5 0 1 0 7 0c0-.739-.603-4.85-.872-6.652zm-2.628 8.152a1.5 1.5 0 1 1 .001-3 1.5 1.5 0 0 1 0 3z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1.10905
    },
    d: "m32.488 6.703-.32 1.188c-.088.328-.376.536-.642.464l-1.449-.39c-.533-.142-.823-.79-.646-1.447.176-.655.752-1.071 1.285-.928l1.448.39c.267.071.412.396.324.723zm-2.73 2.45c.176-.655-.114-1.303-.647-1.447l-1.448-.39c-.267-.07-.555.137-.643.465l-.319 1.188c-.088.328.057.652.323.724l1.449.389c.533.143 1.109-.273 1.285-.928zm-1.605 2.117c-.176.656.114 1.304.647 1.447l1.448.39c.267.071.555-.137.643-.464l.32-1.188c.087-.328-.057-.652-.324-.724l-1.449-.39c-.533-.143-1.108.273-1.285.929zm.327 2.635c.177-.656-.113-1.304-.646-1.447l-1.448-.39c-.267-.071-.555.137-.643.464l-.32 1.188c-.087.328.057.652.324.724l1.448.39c.534.143 1.11-.273 1.285-.929zm-1.604 2.116c-.176.656.113 1.304.647 1.448l1.448.39c.267.07.554-.137.643-.465l.319-1.188c.088-.328-.057-.652-.323-.724l-1.449-.389c-.533-.143-1.109.273-1.285.928zM25.6 20.773c-.176.655.113 1.304.646 1.447l1.449.39c.266.071.554-.137.642-.465l.32-1.188c.088-.327-.057-.652-.324-.723l-1.448-.39c-.533-.143-1.109.273-1.285.929zm1.604-2.117c.176-.655-.113-1.304-.646-1.447l-1.449-.39c-.266-.071-.554.137-.642.465l-.32 1.188c-.088.327.057.652.324.723l1.448.39c.533.143 1.109-.273 1.285-.929z",
    fill: "#c28200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c28200",
    d: "m15.39 6.703.32 1.188c.088.328.376.536.642.464l1.449-.39c.533-.142.822-.79.646-1.447-.176-.655-.752-1.071-1.285-.928l-1.449.39c-.266.071-.41.395-.323.723Zm2.73 2.45c-.176-.655.113-1.303.646-1.447l1.449-.39c.266-.07.554.137.642.465l.32 1.188c.088.328-.057.652-.323.724l-1.449.389c-.533.143-1.109-.273-1.285-.928zm1.604 2.117c.177.656-.113 1.304-.646 1.447l-1.449.39c-.266.071-.554-.136-.642-.464l-.32-1.188c-.088-.328.057-.652.324-.724l1.448-.39c.533-.143 1.109.273 1.285.929zm-.327 2.635c-.176-.655.114-1.304.647-1.447l1.448-.39c.267-.071.555.137.643.464l.319 1.188c.088.328-.057.652-.323.724l-1.449.39c-.533.143-1.109-.273-1.285-.929zm1.605 2.116c.176.656-.114 1.305-.647 1.448l-1.448.39c-.267.071-.555-.137-.643-.465l-.32-1.188c-.087-.328.057-.652.324-.723l1.449-.39c.533-.143 1.108.273 1.285.928zm1.277 4.752c.176.656-.113 1.304-.647 1.447l-1.448.39c-.267.071-.554-.136-.643-.464l-.319-1.188c-.088-.328.057-.652.323-.724l1.449-.39c.533-.143 1.109.273 1.285.929zm-1.605-2.116c-.176-.656.114-1.304.647-1.448l1.448-.39c.267-.07.555.137.643.465l.32 1.188c.087.328-.057.652-.324.724l-1.448.389c-.534.143-1.11-.273-1.286-.928z",
    style: {
      strokeWidth: 1.10906
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e97c01",
    style: {
      fill: "#ffecb3",
      fillOpacity: 1
    },
    d: "M22 25 17 5h14l-5 20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c28200",
      fillOpacity: 1
    },
    fill: "#e97c01",
    d: "M22 24h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c28200",
      fillOpacity: 1
    },
    d: "M26 25.999c-.13 0-.26-.02-.38-.08-.12-.05-.23-.12-.33-.21-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.1-.09.21-.16.33-.21.37-.16.81-.07 1.09.21.18.19.29.45.29.71 0 .07-.01.13-.02.2-.01.06-.03.12-.06.18-.02.06-.05.12-.09.18-.03.05-.08.1-.12.15-.05.04-.1.09-.15.12-.06.04-.12.07-.18.09-.06.03-.12.05-.18.06-.07.01-.13.02-.2.02zm-4 0c-.07 0-.13-.01-.2-.02a.636.636 0 0 1-.18-.06.757.757 0 0 1-.18-.09c-.05-.03-.1-.08-.15-.12-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.38-.37 1.05-.37 1.42 0 .18.19.29.45.29.71 0 .07-.01.13-.02.2-.01.06-.03.12-.06.18-.02.06-.05.12-.09.18-.03.05-.08.1-.12.15-.05.04-.1.09-.15.12-.06.04-.12.07-.18.09-.06.03-.12.05-.18.06-.07.01-.14.02-.2.02z",
    fill: "#e97c01"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetUnarchive);
export default __webpack_public_path__ + "static/media/datasetUnarchive.57a9bec76cfeb2da2ea3f37420398f70.svg";
export { ForwardRef as ReactComponent };